import React from 'react';

type Props = {
  style?: React.CSSProperties;
  onClick?: () => void;
  text?: string;
  animateSheen?: boolean;
  fontFamily?: string;
  padding?: number;
};


export default function ChoshiiLogo({
  style,
  onClick,
  text = 'UNYDO',
  animateSheen,
  fontFamily,
  padding = 0,
}: Props)
{
return (
    <div
      onClick={onClick}
      style={{
        display: 'inline-block',
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
    >
      <div style={{ width: '72%', aspectRatio: '1000 / 300' }}>
        <svg
          viewBox="0 0 1000 300"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid meet"
        >
          <defs>
            <linearGradient id="goldFill" x1="0" y1="0" x2="0" y2="300">
              <stop offset="0%" stopColor="#6f5b2e" />
              <stop offset="18%" stopColor="#b08d3b" />
              <stop offset="40%" stopColor="#ffd87a" />
              <stop offset="65%" stopColor="#b88a2b" />
              <stop offset="100%" stopColor="#695224" />
            </linearGradient>

            <linearGradient id="goldStroke" x1="0" y1="0" x2="0" y2="300">
              <stop offset="0%" stopColor="#f4e3a1" />
              <stop offset="50%" stopColor="#caa64f" />
              <stop offset="100%" stopColor="#8a6a2a" />
            </linearGradient>
          </defs>

          <rect x="0" y="0" width="1000" height="300" fill="transparent" />

          <g transform="translate(500,150)">
            <text
  x="0"
  y="12"
  fontSize="164"
  fill="url(#goldFill)"
  textAnchor="middle"
  dominantBaseline="middle"
  style={{ fontFamily }}
>
  {text}
</text>

            <text
              x="0"
              y="12"
              fontSize="164"
              fill="none"
              stroke="url(#goldStroke)"
              strokeWidth="2"
              textAnchor="middle"
              dominantBaseline="middle"
            >
              {text}
            </text>
          </g>
        </svg>
      </div>
    </div>
  );
}
